const resources = {
  en: {
    common: {
      checkout: {
        details: 'Details',
        completeYourPurchase: 'Complete Your Purchase',
        offersCount: '{{count}} Offers',
        tapToViewOfferDetails: 'Tap to view details',
        offersOverflow: '+{{count}}',
        subtotal: 'Subtotal',
        tax: 'Tax',
        total: 'Total',
        totalDueToday: 'Total due today',
        per: 'per',
        subscribeTo: 'Subscribe to',
        subscription: 'Subscription',
        firstPaymentDiscount: 'First payment discount',
        billed: 'Billed',
        periodDay: 'day',
        periodWeek: 'week',
        periodMonth: 'month',
        periodYear: 'year',
        poweredBy: 'Powered by',
        continueOnDesktop: 'Continue on desktop',
        privacyPolicy: 'Privacy Policy',
        refundPolicy: 'Refund Policy',
        somethingWentWrong: 'Something went wrong',
        unableToLoadCheckout: 'Unable to Open Checkout',
        tryAgainLater: 'Please try again in a moment.',
        unableToCompleteOrder: "We couldn't complete your order.\nPlease contact support for assistance",
        paymentProcessingFailed: 'Unable to Process Payment',
        reopenAndTryAgain: 'Please reopen the checkout and try again.',
        paymentMethodUnavailableCloseTab: 'This payment method is unavailable.\nClose the tab to choose another option',
        pay: 'Pay',
        apply: 'Apply',
        promoCode: 'Promo Code',
        addPromoCode: 'Add Promo Code',
        invalid: 'Invalid',
        expired: 'Expired',
        inactive: 'Inactive',
        discount: 'Discount',
        payButtonDisclaimerPrefix:
          'By clicking "Pay" you indicate that you have read, understood and agree to Appcharge\'s',
        subscriptionAgreementPrefix: 'By purchasing you agree to the Appcharge',
        endUserLicenseAgreement: 'EULA',
        and: 'and',
        cardholderName: 'Cardholder Name',
        blikCode: 'BLIK code (6 digits)',
        emailAddress: 'Email Address',
        firstName: 'First Name',
        lastName: 'Last Name',
        phoneNumber: 'Phone Number',
        address: 'Address',
        cardNumber: 'Card Number',
        expiration: 'Expiration',
        zip: 'ZIP Code',
        postalCode: 'Postal Code',
        city: 'City',
        remove: 'Remove',
        creditCard: 'Card',
        cvc: 'CVC',
        backToGame: 'Back to Game',
        newCard: 'Add New Card',
        changeOrAddCard: 'Change or Add Card',
        savedCards: 'Saved Cards',
        delete: 'Delete',
        select: 'Select',
        cancel: 'Cancel',
        change: 'Change',
        other: 'Other',
        orPayAnotherWay: 'Or pay another way',
        saveCardCheckbox: 'Save my card details for future purchases',
        savePaypalCheckbox: 'Save my PayPal details for future purchases',
        payWith: 'Pay with',
        selectAnOption: 'Select an option',
        selectPaymentMethod: 'Select Payment Method',
        payWithDebitOrCreditCard: 'Pay with Debit or Credit Card',
        paymentMethodNotAvailable:
          "This payment method isn't available right now. Please go back and try selecting a different method.",
        purchaseCompleted: 'Purchase Completed!',
        orderId: 'Order ID: {{id}}',
        wellBeRightBack: "We'll Be Right Back",
        checkoutUnavailable: 'Checkout is temporarily unavailable.',
        support: 'Support',
        contactSupport: 'Contact Support',
        secureAndEncrypted: 'Secure and encrypted',
        processing: 'Processing',
        pleaseCompletePaymentInWindow: 'Please complete payment in the opened window',
        cancelPayment: 'Cancel payment',
        blikApprovalTitle: 'Confirm the payment in your banking app',
        blikApprovalSubtitle: 'Approve the BLIK request within 60 seconds to complete your purchase.',
        bizumApprovalTitle: 'Authorize the payment in your banking app',
        bizumApprovalSubtitle:
          'Confirm the Bizum payment in your mobile banking application to complete your purchase.',
        mbwayApprovalTitle: 'Authorize the payment in your MB WAY app',
        mbwayApprovalSubtitle: 'Confirm the MB WAY payment in your app to complete your purchase.',
        backToStore: 'Back to Store',
        failedToRemovePromoCode: 'Failed to remove promo code. Please try again',
        couponDoesNotExist: 'Promo code is invalid. Check the spelling and try again.',
        maxCardsReached: "You've reached the maximum of {{max}} saved cards. Remove a card to add a new one.",
        provideValidZipCode: 'Please provide a valid ZIP code to proceed with the payment',
        provideValidPostalCode: 'Please provide a valid postal code to proceed with the payment',
        back: 'Back',
        paymentMethodBrowserNotSupported: "This payment method isn't supported in your current browser.",
        useOtherPaymentMethod: 'Use Other Payment Method',
        rotateYourPhoneForBestExperience: 'Rotate your phone for the best experience',
        noResultsFound: 'No results found',
        securePaymentVerification: 'Secure Payment Verification',
        subscribeAndPay: 'Subscribe & Pay',
        activeSubscriptionExists: 'Subscription already active',
        activeSubscriptionExistsDescription: 'An active subscription is already available for this account.',
        subscriptionRenewalDisclaimer:
          'Your subscription will automatically renew {{period}} starting today. You will be charged the amount of {{amount}} {{taxes}}. Cancel at any time in the Customer Portal.',
        IOFDisclaimer_pt:
          'De acordo com a regulamentação brasileira, esta compra internacional está sujeita a um IOF de 3,5% devido à operação de câmbio envolvida.',
        taxesIncluded: 'included taxes',
        taxesExcluded: 'excluded taxes',
        renewalPeriodDaily: 'daily',
        renewalPeriodWeekly: 'weekly',
        renewalPeriodMonthly: 'monthly',
        renewalPeriodAnnually: 'annually',
        doNotSell: 'Do Not Sell My Data',
        doNotSellTitle: 'Notice of Right to Opt-Out of Sale/Sharing',
        doNotSellBody:
          "As a resident of California or another applicable U.S. state, you may have the right to direct us not to sell or share your personal information. Appcharge may sell personal information, specifically your email address, to the game publisher whose store or checkout you used, for that publisher's marketing purposes.",
        doNotSellContactPrefix: 'You can also submit your request by contacting',
        doNotSellContactSuffix:
          '. You do not need to create an account to opt out, and we will only use the information you provide to process your request. We also treat a recognized opt-out preference signal sent by your browser, such as Global Privacy Control, as a valid request to opt out for that browser or device.',
        doNotSellPrivacyPrefix: 'For more information about our privacy practices, please see our',
        doNotSellCopyEmail: 'Copy email address',
        doNotSellOptOut: 'Do not sell my data',
        doNotSellSuccess:
          'Your request has been received. We will stop selling or sharing your personal information as soon as feasible. You will not be asked to consent to the sale or sharing of your personal information again for at least 12 months. If you have questions, contact privacy@appcharge.com',
        doNotSellError: 'Unable to save your preference. Please try again',
        close: 'Close',
        retry: 'Retry',
        fieldErrors: {
          incomplete: 'Your {{field}} is incomplete.',
          incomplete_cvc: 'Incomplete cvc',
          incomplete_date: 'Incomplete date',
          date_in_past: 'Date in past',
          invalid_expiration_year: 'Invalid expiration year',
          incomplete_card_number: 'Incomplete card number',
          incorrect_card_number: 'Incorrect card number',
          incompleteEmail: 'Your email address is incomplete.',
          invalidEmail: 'Your email address is invalid.',
          incompleteCardholderName: 'Cardholder name is incomplete.',
          missingZipCode: 'Missing ZIP code.',
          invalidZipCode: 'Invalid ZIP code.',
          missingPostalCode: 'Missing Postal Code.',
          invalidPostalCode: 'Invalid Postal Code.',
          invalidCard: 'Your card number is invalid.',
          incompleteCard: 'Your card number is incomplete.',
          incompleteExpirationDate: "Your card's expiration date is incomplete.",
          invalidExpirationDate: "Your card's expiration year is invalid.",
          incompleteSecurityCode: "Your card's security code is incomplete.",
          invalidSecurityCode: "Your card's security code is invalid.",
          invalidFormat: 'Invalid format for {{field}}',
          twoWordsRequired: '{{field}} must contain first and last name',
          invalidBlikCode: 'Enter the 6-digit BLIK code from your banking app.',
          shopperName: 'Your name must be two words and contain only letters',
          shopperEmail: 'Your email address is invalid.',
          telephoneNumber: 'Your phone number must contain only numbers',
          invalidAddress: 'Address must be at least 7 characters long.',
        },
        appchargeErrors: {
          generic: 'Payment could not be processed. Please try again or use a different method.',
          incorrectCvc: 'The security code is incorrect. Please try again.',
          timeout: 'The payment request timed out. Please try again.',
          expiredCard: 'Your card has expired. Please use a different card.',
          cardNotSupported: 'Your card is not supported. Please use a different payment method.',
          insufficientFunds: 'Payment could not be processed. Please try again or use a different method.',
          connection: 'There was a connection error. Please check your internet connection and try again.',
          transactionNotPermitted: 'Payment could not be processed. Please use a different method.',
          authorizationError: 'The payment was not authorized. Please try again or use a different method.',
          suspectFraud: 'Payment could not be processed. Please use a different payment method.',
          authenticationRequired: 'Payment could not be processed. Please try again or use a different method.',
          authenticationNotHandled: 'Payment could not be processed. Please try again or use a different method.',
          approveWithId: 'Payment could not be processed. Please use a different method.',
          cardVelocityExceeded:
            'Too many payment attempts. Please wait a moment and try again, or use a different payment method.',
          currencyNotSupported:
            'This card doesn’t support the selected currency. Please use a different payment method.',
          duplicateTransaction:
            'A similar payment was just made. Check if you were already charged before trying again.',
          genericDecline: 'Payment could not be processed. Please try again or use a different method.',
          incorrectAddress: 'The billing address is incorrect. Update it or use a different method.',
          invalidZip: 'The postal code is incorrect. Please check and try again.',
          invalidAccount: 'Payment could not be processed. Please use a different method.',
          invalidAmount: 'Payment could not be processed. Please use a different method.',
          invalidCvc: 'The security code is incorrect. Please try again.',
          invalidExpiryDate: 'The expiration date is incorrect. Please try again.',
          invalidNumber: 'The card number is incorrect. Please try again.',
          invalidPin: 'The PIN is incorrect. Please try again.',
          notPermitted: 'Payment could not be processed. Please try again or use a different method.',
          pinTryExceeded: 'Payment could not be processed. Please try again using a different method.',
          processingError: 'Payment could not be processed. Please try again or use a different method.',
          revocationOfAuthorization: 'Payment could not be processed. Please use a different method.',
          withdrawalCountLimitExceeded:
            'Too many payment attempts. Please wait a moment and try again, or use a different payment method.',
          blikInvalidCode:
            'That BLIK code is invalid or has expired. Open your banking app, get a new 6-digit code, and try again.',
          blikTimeout:
            "Your BLIK payment wasn't confirmed in time. Please try again and approve the request in your banking app.",
          paymentMethodNotAvailableChooseAnotherMethod:
            "This payment method isn't available right now. Please choose another method.",
          paymentMethodNotAvailableGoBackAndTrySelectingAnotherMethod:
            'This payment method is unavailable. Close the checkout to choose another option.',
        },
        venmoErrors: {
          sessionTimeout: 'Your Venmo session timed out. Try again.',
          connection: 'Connection issue. Check your internet and try again.',
          unknown: "We couldn't complete your payment. Try again or use a different payment method.",
        },
      },
    },
  },
};

export default resources;
